import { StackingDashboard } from './StackingDashboard';

export default StackingDashboard;
